import { PageHero, SitePage } from "@/components/SitePage";
import SectionLabel from "@/components/SectionLabel";
import HomeClosingCTA from "@/components/HomeClosingCTA";

const projects = [
  {
    number: "01",
    sector: "Healthcare operations",
    title: "Voice agents for a diagnostics chain.",
    description:
      "A 24/7 voice agent handling ~2,000 calls a day in Hindi, English and Bengali: home-collection and outpatient bookings, test-report queries and general queries, with 72% resolved without a human.",
    stage: "Live in production",
    href: "/work/diagnostics-voice-agent",
    image: "/case-studies/healthcare-lab.jpg",
    imageAlt: "Diagnostic laboratory technician operating analysis equipment",
  },
  {
    number: "02",
    sector: "Industrial operations",
    title: "AI order capture for a steel manufacturer.",
    description:
      "A multichannel AI order-capture system processing 5,000+ handwritten WhatsApp orders a month across 150 SKUs into verified ERP drafts, with a phone-call channel being added next.",
    stage: "Live · Expanding",
    href: "/work/whatsapp-order-capture",
    image: "/case-studies/steel-manufacturing.jpg",
    imageAlt: "Steelworkers overseeing an industrial steel furnace",
  },
];

export default function Work() {
  return (
    <SitePage>
      <PageHero
        label="Case studies"
        title="Technology transformation in practice."
        intro="Selected examples of how Averentia applies technology and AI to operating requirements. Each brief states the scope and stage of the work."
        aside={<><span>Focus</span><strong>Operations<br />Systems<br />Adoption</strong></>}
      />
      <section className="av-section av-page-section" aria-labelledby="selected-projects">
        <div className="av-shell">
          <SectionLabel>Case studies</SectionLabel>
          <h2 id="selected-projects" className="av-work-heading">Case studies.</h2>
          <div className="av-work-list">
            {projects.map((project) => (
              <a className="av-work-record" href={project.href} key={project.number}>
                <figure className="av-work-thumb">
                  <img src={project.image} alt={project.imageAlt} />
                </figure>
                <div className="av-work-record-copy">
                  <span className="av-index">{project.number} / {project.sector}</span>
                  <h3>{project.title}</h3>
                  <p>{project.description}</p>
                </div>
                <span className="av-record-link">{project.stage}<br />Read case study →</span>
              </a>
            ))}
          </div>
        </div>
      </section>
      <HomeClosingCTA />
    </SitePage>
  );
}
